import { z } from 'zod';
import { UuidSchema } from './uuid';

export const ShareResultKindSchema = z.enum(['win', 'lose', 'score', 'time', 'partial']);

export const ShareSessionResultSchema = z.object({
  kind: ShareResultKindSchema,
  score: z.number().int().nullable().optional(),
  duration_ms: z.number().int().nullable().optional(),
});

export const ShareCompositeStatusSchema = z.enum(['queued', 'rendering', 'ready', 'failed']);

export const ShareAttemptCompositeSchema = z.object({
  status: ShareCompositeStatusSchema,
  template_version: z.string(),
  duration_ms: z.number().int().nullable().optional(),
  thumbnail_url: z.string().url().nullable().optional(),
  preview_url: z.string().url().nullable().optional(),
  download_url: z.string().url().nullable().optional(),
  export_url: z.string().url().nullable().optional(),
});

export const ShareAttemptChallengeSchema = z.object({
  challenge_id: UuidSchema,
  public_id: z.string(),
  challenge_url: z.string().url(),
  default_utm_source: z.string(),
  default_utm_medium: z.string(),
  default_utm_campaign: z.string(),
  default_utm_content: z.string(),
  default_utm_id: z.string(),
  cta_headline: z.string(),
  cta_label: z.string(),
});

export const ShareSessionAttemptSchema = z.object({
  attempt_id: UuidSchema,
  attempt_no: z.number().int(),
  result_kind: ShareResultKindSchema.nullable().optional(),
  started_at: z.string().nullable().optional(),
  ended_at: z.string().nullable().optional(),
  composite: ShareAttemptCompositeSchema.nullable().optional(),
  challenge: ShareAttemptChallengeSchema.nullable().optional(),
  challenge_composite: ShareAttemptCompositeSchema.nullable().optional(),
});

export const ShareSessionResponseSchema = z.object({
  session_id: UuidSchema,
  played_at: z.string().nullable().optional(),
  game_type_key: z.string().nullable().optional(),
  robot_name: z.string().nullable().optional(),
  session_result: ShareSessionResultSchema.nullable().optional(),
  attempts: z.array(ShareSessionAttemptSchema),
});

export type ShareResultKind = z.infer<typeof ShareResultKindSchema>;
export type ShareCompositeStatus = z.infer<typeof ShareCompositeStatusSchema>;
export type ShareSessionResult = z.infer<typeof ShareSessionResultSchema>;
export type ShareAttemptComposite = z.infer<typeof ShareAttemptCompositeSchema>;
export type ShareAttemptChallenge = z.infer<typeof ShareAttemptChallengeSchema>;
export type ShareSessionAttempt = z.infer<typeof ShareSessionAttemptSchema>;
export type ShareSessionResponse = z.infer<typeof ShareSessionResponseSchema>;
